import { Button } from 'modules/Button';
import { Menu } from 'modules/Menu';
import { Falcon } from 'modules/macro';
import { Container, ButtonText } from './styled';
export function TableBulkActions(props) {
    const { children, label, checkbox, menuVisible } = props;
    return (<Container>
      {checkbox}
      {menuVisible && (<Menu.Root target={<Button appearance="ghost" size="small">
              <ButtonText>{label}</ButtonText>
              <Falcon icon="chevron-down"/>
            </Button>}>
          {children}
        </Menu.Root>)}
    </Container>);
}
